<template>
  <div>
    <div class="text-center mb-4">
      <h2 class="h3">How does ZoopLocal work?</h2>
    </div>
    <b-row class="my-4 mx-0">
      <b-col
        class="bg-light text-center py-5"
        :cols="12"
        :lg="6">
        <img
          height="75"
          width="75"
          class="p-2"
          src="/images/home/buy.png">
        <h2>Buy</h2>
        <p>Furnish your home from home.</p>
        <b-row>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">1. Search</h3>
            <p>
              Find your treasure without the hunt.
            </p>
          </b-col>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">2. Select</h3>
            <p>
              Reserve it before your neighbor gets
              to it first!
            </p>
          </b-col>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">3. Schedule</h3>
            <p>
              Coordinate directly with the seller
              on delivery.
            </p>
          </b-col>
        </b-row>
        <b-button
          variant="outline-dark"
          to="listings"
          squared>
          Buy on Zoop
        </b-button>
      </b-col>
      <b-col
        class="bg-primary text-center py-5 text-light"
        :cols="12"
        :lg="6">
        <img
          width="75"
          height="75"
          src="/images/home/sell.png"
          class="p-3">
        <h2>Sell</h2>
        <p>Why store it when you can sell it?</p>
        <b-row>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">1. Show</h3>
            <p>
              Take a picture and share your item's
              details.
            </p>
          </b-col>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">2. Secure</h3>
            <p>
              Confirm purchase requests within
              24 hours.
            </p>
          </b-col>
          <b-col
            class="py-3"
            :cols="12"
            :md="4">
            <h3 class="h4">3. Schedule</h3>
            <p>
              Coordinate directly with the buyer
              on delivery.
            </p>
          </b-col>
        </b-row>
        <b-button
          to="/account/listings/new"
          variant="light"
          squared>
          Sell on Zoop
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HomeBuySell',
}
</script>

<style lang="scss" scoped>
</style>
